import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5910b255"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-center justify-between dark:bg-dark-600 bg-primary-10" }
const _hoisted_2 = { class: "w-full h-full flex flex-col" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "mt-auto"
}
const _hoisted_5 = {
  key: 2,
  class: "mt-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideMenuButton = _resolveComponent("SideMenuButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createVNode(_component_SideMenuButton, {
          icon: 'code',
          isDisabled: _ctx.rightSideFrame == 'Editor',
          text: _ctx.$t('message.editor'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setRightSideFrame('Editor')))
        }, null, 8, ["isDisabled", "text"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_SideMenuButton, {
          id: "judge",
          icon: 'assessment',
          isDisabled: _ctx.rightSideFrame == 'JudgeDetail',
          text: _ctx.$t('message.judgeDetail'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setRightSideFrame('JudgeDetail')))
        }, null, 8, ["isDisabled", "text"])
      ]),
      (_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _createVNode(_component_SideMenuButton, {
              icon: 'rate_review',
              isDisabled: _ctx.rightSideFrame == 'ReviewPost',
              text: _ctx.$t('message.submitReview'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setRightSideFrame('ReviewPost')))
            }, null, 8, ["isDisabled", "text"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, [
        _createVNode(_component_SideMenuButton, {
          icon: 'view_list',
          isDisabled: _ctx.rightSideFrame == 'JudgeQueue',
          text: _ctx.$t('message.recentSubmissions'),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setRightSideFrame('JudgeQueue')))
        }, null, 8, ["isDisabled", "text"])
      ]),
      (
          _ctx.arenaPresenter.arenaId.value != '' &&
          _ctx.arenaPresenter.arenaProblemIndex.value + 1 < _ctx.arenaPresenter.arenaProblemElementList.value.length
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createVNode(_component_SideMenuButton, {
              icon: 'arrow_forward',
              text: _ctx.$t('message.nextProblem'),
              onClick: _cache[4] || (_cache[4] = () => _ctx.setNextArenaProblem())
            }, null, 8, ["text"])
          ]))
        : (_ctx.arenaPresenter.arenaId.value == '' && _ctx.problemStatePresenter.nextProblemId.value != '-1')
          ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
              _createVNode(_component_SideMenuButton, {
                icon: 'arrow_forward',
                text: _ctx.$t('message.nextProblem'),
                onClick: _cache[5] || (_cache[5] = () => _ctx.problemStatePresenter.setProblemId(_ctx.problemStatePresenter.nextProblemId.value))
              }, null, 8, ["text"])
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}